import React, { createContext, useContext, useState } from "react";
import { IncomesProvider } from "./incomes.context";
import { ExpensesProvider } from "./expenses.context";

type pageType = string | undefined;

interface DashboardContextType {
  page: pageType;
  changePage: (dashboardPage: string) => void;
}

interface Props {
  children: React.ReactNode;
}

export const DashboardContext = createContext<DashboardContextType>(
  {} as DashboardContextType
);

export const DashboardProvider = ({ children }: Props) => {
  const [page, setPage] = useState<pageType>("Expenses");

  const changePage = (dashboardPage: string) => {
    setPage(dashboardPage);
  };

  return (
    <IncomesProvider>
      <ExpensesProvider>
        <DashboardContext.Provider
          value={{
            page,
            changePage,
          }}
        >
          {children}
        </DashboardContext.Provider>
      </ExpensesProvider>
    </IncomesProvider>
  );
};

export const useDashboard = () => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error("useDashboard must be used within an DashboardProvider");
  }
  return context;
};
